
import styled from 'styled-components'

export const PropertyTypeWelcomeWrapper = styled.div`     

    //border: 1px solid red;
    h1{
        color: #6262A0;
        font-size: 3em;
        font-weight: 400;/*Toma la variacion regular 400 de Roboto*/
        margin: 0;
    }

    h2{
        color: #C0C2D2;
        font-size: 2.2em;
        font-weight: 400;/*Toma la variacion regular 400 de Roboto*/
        margin: 0;
        text-align: left;

        span{            
            color: #6262A0;
            font-weight: bold;           
        }

      
    }    
`